import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { BoxBone } from '../../atoms/BoxBone/BoxBone';
import { TextBone } from '../../atoms/TextBone/TextBone';

interface SearchFieldBoneProps {
    /** Afficher les filtres sous la barre */
    showFilters?: boolean;
    /** Nombre de filtres */
    filterCount?: number;
    /** Hauteur de la barre de recherche */
    searchHeight?: string;
    /** Styles personnalisés */
    sx?: SxProps<Theme>;
}

export const SearchFieldBone: React.FunctionComponent<SearchFieldBoneProps> = function ({
    showFilters = true,
    filterCount = 3,
    searchHeight = '56px',
    sx = {},
}) {
    return (
        <Box sx={{ width: '100%', padding: '16px', ...sx }}>
            <BoxBone sx={{ width: '100%', height: searchHeight, marginBottom: 1 }} />
            {showFilters && (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: 1,
                        width: '50%',
                    }}
                >
                    {Array.from({ length: filterCount }).map((_, index) => (
                        <TextBone
                            key={`search-filter-${filterCount}-${index + 1}`}
                            sx={{ width: `${100 / filterCount}%`, height: '24px' }}
                        />
                    ))}
                </Box>
            )}
        </Box>
    );
};
